import React from 'react'
import { FormattedMessage } from 'react-intl'
import { string, shape, number } from 'prop-types'
import TextFormatter from 'react-currency-format'
import { Download, Whatsapp } from '@gympass/yoga-icons'
import tokens from '@gympass/yoga-tokens'

import getCommercialOfferPdf from '@client/services/print'
import { isMobile } from '@client/utils/browserUserAgent'
import defaultReportNameByCountry from '@client/mapper/defaultReportNameByCountry'

import useDataLayer from '@hooks/useDataLayer'
import useInternationalization from '@hooks/useInternationalization'

import {
  ProposalActions,
  ProposalActionsItem,
  ProposalActionsDescription,
} from './OfferActions.style'

export default function OfferActions({ contact }) {
  const { country } = useInternationalization()
  const { events } = useDataLayer()
  const whatsappNumber = 11965460883

  function generateWhatsAppLink() {
    const whatsAppPrefix = isMobile() ? 'api' : 'web'
    return `https://${whatsAppPrefix}.whatsapp.com/send?phone=55${whatsappNumber}&text&app_absent=0`
  }

  function handleTalkToSpecialist() {
    const whatsAppLink = generateWhatsAppLink()
    window.open(whatsAppLink, '_blank')
    events.interactionWithContactRequest()
  }

  function handleDownloadFile(file) {
    const url = window.URL.createObjectURL(new Blob([file]))

    const link = document.createElement('a')

    link.href = url

    link.setAttribute(
      'download',
      `${defaultReportNameByCountry[country]}-${contact.company}.pdf`
    )

    document.body.appendChild(link)

    link.click()
  }

  async function getCommercialOfferFile() {
    const discount =
      contact.proposalValue - contact.proposalValueWithoutDiscount

    const data = {
      personalInfo: {
        company: contact.company,
        fullName: `${contact.firstName} ${contact.lastName}`,
        email: contact.email,
        phone: contact.mobilePhone,
      },
      companyInfo: {
        employeesNumber: contact.employeesNumber,
      },
      commercialOffer: {
        originalValue: contact.proposalValueWithoutDiscount,
        value: contact.proposalValue,
        discount,
      },
    }

    const response = await getCommercialOfferPdf(data, country)

    handleDownloadFile(response.data)

    events.interactionWithProposalDownload()
  }

  return (
    <ProposalActions>
      <ProposalActionsItem onClick={getCommercialOfferFile}>
        <Download fill={tokens.colors.vibin} width={24} height={24} />
        <ProposalActionsDescription>
          <FormattedMessage id="smb_acquisition_commercial_offer.media.proposal_download" />
        </ProposalActionsDescription>
      </ProposalActionsItem>

      {contact.employeesNumber <= 100 && (
        <ProposalActionsItem onClick={handleTalkToSpecialist}>
          <Whatsapp fill={tokens.colors.vibin} width={24} height={24} />
          <ProposalActionsDescription>
            WhatsApp{' '}
            <TextFormatter
              value={whatsappNumber}
              displayType="text"
              format="(##) #####-####"
            />
          </ProposalActionsDescription>
        </ProposalActionsItem>
      )}
    </ProposalActions>
  )
}

OfferActions.propTypes = {
  contact: shape({
    employeesNumber: number,
    id: string,
    specialistCalendar: string,
  }).isRequired,
}
